module.exports = __webpack_public_path__ + "static/securityonyournetwork-77097341595fbc953c7fd44d001ff09e.png";